import React from "react";

export default function PageHero({ tagline, title, highlight, subtitle, crumb }) {
  return (
    <section className="relative bg-cream bg-dotted overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 py-20 md:py-28 text-center">
        <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">{tagline}</p>
        <h1 className="font-display text-4xl md:text-6xl font-bold text-neutral-900 mt-3">
          {title} {highlight && <span className="text-orange-500">{highlight}</span>}
        </h1>
        <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-5" />
        {subtitle && <p className="mt-5 text-neutral-600 max-w-2xl mx-auto">{subtitle}</p>}
      </div>
      {crumb && (
        <div className="border-t border-neutral-200/70 bg-white/40 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto px-6 py-4 text-sm text-neutral-600">{crumb}</div>
        </div>
      )}
    </section>
  );
}
